<template>
<div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="configEditLabel">Edit Configuration File</h5>

          <button type="button" class="btn-close" @click="$emit('closeModal')"></button>
        </div>
        <div class="modal-body">
          <form id="configEditForm" method="post" v-if="formActive">
            <div class="form-group">
              <label>Filetype</label>
              <select class="form-select" v-model="selectedfiletype" @click="selectFileType">
                <option value="mdl">Model (MDL)</option>
                <option value="loc">Location (LOC)</option>
                <option value="cfg">Configuration (CFG)</option>
                <option value="pqr" v-if="this.isAdmin">Prospect Query (PQR)</option>
              </select>
            </div>

            <div class="form-group" v-if="selectedfiletype != ''">
              <label>Select file to edit</label>
              <select class="form-select" v-model="selectedfile" @click="selectFile">
                <option v-for="option in sortedItems" :value="option" :key="option">{{option}}</option>
                <option value="new">New</option>
              </select>
            </div>
            <div class="form-group" v-if="selectedfile === 'new'"> 
              <input id="name" name="name" class="form-control" v-model="newname" />
            </div>
            <div class="form-group">
              <textarea id="cfgContents" name="cfgContents" class="form-control" rows="15" cols="45" v-model="loadedcontent"></textarea>
            </div>
            <div class="form-group">
              <button type="button" class="btn btn-light" @click="$emit('closeModal')">Cancel</button>
              <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                id="configUpdateButton" v-on:click="saveFile()">Update</button>
            </div>
          </form>
          <div v-else>
            <h3 class="text-center">File Saved...</h3>
            <button type="button" class="btn btn-light" @click="$emit('closeModal')">Close Window</button>
          </div>
        </div>
      </div>
</template>
<script>
import axios from 'axios';
export default {
  name: "Modal Config Edit",
  components: {  },
  props: {
    passedData: {
      type: String,
      default() {
        return "Dataset";
      },
    },
    isAdmin: {
      type: Boolean,
        default() {
          return false
        }
    }
  },
  data() {
    return {
      //returnedfiles: [],
      filelist: [],
      loadedcontent: '',
      newname: '',
      selectedfile: '',
      selectedfiletype: '',
      formActive: true
    };
  },
  methods: {
    selectFile() {
      if(this.selectedfile != 'new') {
        console.log('selected value is '+this.selectedfile);
        this.loadContent(this.selectedfile);
      } else {
        this.loadedcontent = '';
      }
    },
    selectFileType() {
      var desiredExtension = "."+this.selectedfiletype;
      this.listFiles(desiredExtension);
    },
    loadContent(val) {
      let formData = new FormData();
      formData.append('selectedfile', val);
      axios({
        method : 'POST',
        url : '/user_config_set',
        data:formData,
      }).then(
        (response) => {
          this.loadedcontent = response.data;
          console.log('list of config files '+response.data);
        })
        .catch(error => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
      });
    },
    listFiles(ext) {
      let formData = new FormData();
      formData.append('extension', ext);
      axios({
        method : 'POST',
        url : '/user_config_list',
        data:formData,
      }).then(
        (response) => {
          this.filelist = response.data;
          console.log('list of config files '+response.data);
        })
        .catch(error => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
      });
    },
    saveFile() {
      let formData = new FormData();
      if(this.newname) {
        formData.append('name', this.newname);
      } else {
        formData.append('name', this.selectedfile.replace(/\.[^/.]+$/, ""));
      };
      formData.append('contents', this.loadedcontent);
      formData.append('extension', "."+this.selectedfiletype)
      for (var pair of formData.entries()) {
          console.log(pair[0]+ ', ' + pair[1]); 
      }
      axios({
        method : 'POST',
        url : '/user_config_save',
        data:formData,
      }).then(
        (response) => {
          // this.filelist = response.data;
          this.formActive = false;
          console.log('save file response '+JSON.stringify(response.data));
        })
        .catch(error => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
      });
    }, 
  },
  computed: {
      sortedItems() {
        return [...this.filelist].sort();
      }
    }
  //mounted() {
    //this.listFiles();
  //}
}
</script>